const maijia = {
    headText0: "We know your needs better",
    headText1: "Branding and performing, we know you better",
    headText2:"Digital marketing mode- show you the performance with data. ",
    headText3:'More valuable than traditional marketing',
    headText4:"We focus on the mode helping you win both brand awareness and sales.",
    headText5: "Without Duomai, still an inch to success.",
    headText6: "Choose us and you will have your exclusive brand steward.",

    serveTitle: "Professional Service",
    serveIllustrate: "The organization to provide integrated localization for brands, to boost both exposure and performance",

    serveTitle1: "Content marketing",
    serveDetail1:"Creative poster，celebrity shout-outs, unboxing videos, marketing within Taobao, interesting long-comics, IP cooperation, live stream, viral hashtags… customize creative content that is insightful , easy-to-spread and highly interactive ",
    serveTitle2: "活动 Campaigns",
    serveDetail2:"Launch marketing campaigns on New year’s day, CNY(Chinese New Year), Valentine’s day, Goddess’s Day, 618 sale, Halloween, Thanks giving day, Double 11, Christmas and Black Friday, to make “phenomenal screen flooding” for your brand.",
    serveTitle3: "Media resources",
    serveDetail3:"400+signed KOL, over 300M users coverage; 600+ further cooperated KOLs, exclusive agency of multiple mainstream media. 350K+ digital media resources covering a wide range in the market——the capability to integrate omnichannel social resources.",
    serveTitle4: "Performance marketing",
    serveDetail4:"ROI guarantee, ensure the return on input, increase the effective utilization of the budget. Provide effective marketing plan for the brands, reach the potential customers precisely and trigger the action of purchasing.",
    serveTitle5: "Data backup",
    serveDetail5:"Self-owned database marking resources from different information dimensions, responds to different needs and precisely match the resources. The system monitor performance 24/7, assess the results scientifically then timely optimize the resource.",

    goodCase: "Typical Cases",
    knowMore: "Know More",
    seeMore: "Learn More",

    maijiaTitle: "Welcome to M+ Advertising",
    maijiaText1:"M+ Advertising is an excellent performance marketing organization based in China, providing the most professional performance marketing services. We have a nation-wide leading omnichannel marketing data system and advertising monitoring system. ",
    maijiaText2: "We promise to provide real and objective data.",
    maijiaText3:"What suits the brand is the best—— our experienced marketing team provide customized marketing plan for your brands, dig out the real needs, precisely target the users. Our strength is to help advertisers to win both brand awareness and sales. To date, we have provided marketing solutions for over a hundred brands.We, M+ Advertising, is the trustworthy partner. To choose M+ Advertising is to win both brand awareness and sales.",

    contactTitle: "Contact Us",
    contactIllustrate:"Please contact us, looking forward to cooperating and developing together",
    submitBtn: "Submit",

    contactAdressTitle: "Address:",
    contactAdressDetail:"8-9 Floors, Donggu Business incubator, #9 Pusheng Street, Jianggan District, Hangzhou, Zhejiang, China",
    contactTelTitle: "Telephone:",
    contactTelDetail: "+86 0571-56638559",
    contactEmailTitle: "Email：",
    contactEmailDetail: "kalika@duomai.com",

    contactText1: "Contact us and you will get",
    contactText2: "Customized marketing plan",
    contactText3: "",
    contactText4: "Omnichannel promotion",
    contactText5: "We would make another “best sellers”",

    contactText6: "Looking forward to your contact",

    partnersTitle: "Some Of Our Clients",

    nextPage: "next",

    DuoMaiTitle: "DUOMAI",
    DuoMaiIllustrate: "Organization for integrated brand marketing service, boosting both brand awareness and sales."
};

export { maijia };
